import Tooltip from './Tooltip'

export default Tooltip



// WEBPACK FOOTER //
// ./components/vc-tooltip/index.js